import React from 'react';
import MuiSwitch from '@shared/components/MuiSwitch';
import { Typography } from '@mui/material';

/**
 * @typedef {object} LabeledSwitchProps
 * @property {string} [title]
 * @property {string} [checkedLabel]
 * @property {string} [uncheckedLabel]
 * @property {string} [testId]
 * @property {boolean} [checked]
 * @property {(event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void} [onChange]
 */

/**
 * @param {LabeledSwitchProps} props
 */
const LabeledSwitch = props => {
  const { title, checkedLabel = '', uncheckedLabel = '', checked, onChange, testId = '' } = props;

  return (
    <div className='label-switch'>
      {title && <span className='bold label'>{title}</span>}

      <div className='switch-root'>
        {checked && (
          <Typography variant='subtitle2' className='label left'>
            {checkedLabel}
          </Typography>
        )}
        <MuiSwitch
          slotProps={{
            input: {
              'data-testid': `${testId}-input`
            }
          }}
          checked={checked}
          disableRipple
          onChange={onChange}
        />
        {!checked && (
          <Typography variant='subtitle2' className='label right'>
            {uncheckedLabel}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default LabeledSwitch;
